'use client';

var s = {"editorContainer":"TextEditor-module_editorContainer__-0-63","isError":"TextEditor-module_isError__1O_EJ","toolbar":"TextEditor-module_toolbar__h9y2b","disabled":"TextEditor-module_disabled__2xwOq","separator":"TextEditor-module_separator__1GYSh","urlInput":"TextEditor-module_urlInput__1u3sO","urlConfirmButton":"TextEditor-module_urlConfirmButton__1YMRI","limitTextError":"TextEditor-module_limitTextError__2ADXg"};

export { s as default };
//# sourceMappingURL=TextEditor.module.scss.js.map
